import React from 'react';
import PropTypes from 'prop-types';
import TeamPlayer from './TeamPlayer';

import '../css/finished-team.css';
import '../css/display-type.css';

class FinishedTeam extends React.Component {

  static propTypes = {
    isFinished: PropTypes.bool,
    selections: PropTypes.object,
    url: PropTypes.string,
    clearTeam: PropTypes.func,
    positionsOfNeed: PropTypes.array,
    signings: PropTypes.array
  }

  createSelectionArray = (selections) => {
    const selectionArray = Object.keys(selections).map(key => selections[key]);
      selectionArray.sort((a,b) => {
        if (a.salary < b.salary) {
          return 1;
        } else {
          return -1;
        }
      });
      return selectionArray;
  }

  formatTweet = (selections, url) => {
    const selectionArray = this.createSelectionArray(selections);
    let tweetMax;
    if (selectionArray.length > 3) {
      tweetMax = 2;
    } else {
      tweetMax = selectionArray.length - 1;
    }

    let tweetText = 'My @Patriots rebuild includes ';

    for (let i = 0; i <= tweetMax; i += 1) {
      if (i !== tweetMax && selectionArray.length >= 3) {
        tweetText += `${selectionArray[i].name}, `;
      } else if (i !== tweetMax && selectionArray.length <= 2) {
        tweetText += `${selectionArray[i].name} `
      } else if (i === tweetMax && selectionArray.length === 1) {
        tweetText += `${selectionArray[i].name}.`;
      } else {
        tweetText += `and ${selectionArray[i].name}.`;
      }
    }

    tweetText += ' Who would you add to the Patriots? '

    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}&via=BostonGlobe&url=${encodeURI(url)}` 

  }

  renderDeck = (isFinished, selections, need) => {
    // if the user hasn't gotten at least the minimum number of players
    // return a deck that tells them how many to get
    if (!isFinished) {
      return null;
    } else {
      // if they have hit the minimum threshold, 
      
      // create a deck string that informs them about their team
      // if they've met the team needs and sums of the players
      let deck = '';

      const positionsDrafted = Object.keys(selections).map(s => selections[s].position);

      let positionsMet = 0;

      need.forEach((pos) => {
        if (positionsDrafted.includes(pos)) {
          positionsMet += 1;
        }
      });

      if (this.props.signings.length === 0) {
        const writtenNumbers = ['zero', 'one', 'two', 'three', 'four', 'five'];

        if (positionsMet === 0) {
          deck += 'Tough offseason. You failed to sign any players that address the Patriots’ positions of need. '
        } else if (positionsMet === 1) {
          deck += 'You could have done better. You signed one player that addresses the positions of need for the Patriots. '
        } else if (positionsMet <= 3) {
          deck += `Nice job. You signed ${writtenNumbers[positionsMet]} players that address the positions of need for the Patriots. `
        } else if (positionsMet <= 5) {
          deck += `Excellent job. You signed ${writtenNumbers[positionsMet]} players that address the positions of need for the Patriots. `
        }
      } else {
        deck += 'Nice job. '
      }
        

      deck += 'Highlights of your additions include: '

      return deck;
    }
  }

  render() {

    const selectionArray = Object.keys(this.props.selections).map(key => this.props.selections[key]);

    selectionArray.sort((a,b) => {
      if (a.salary <= b.salary) {
        return 1;
      } return -1;
    })
    
    return (
      <div>
        <div id="finished-team__container"  className="bucket">
          <div className="bucket__header">
            <h5>Your additions</h5>
            <p>
            {this.renderDeck(this.props.isFinished, this.props.selections, this.props.positionsOfNeed)}
              {selectionArray.map((value, index) => {
                if (index <= 2) {
                  return (
                  <span key={`finished-${value.name}`}>
                    <strong>
                      {value.name}:&nbsp;
                    </strong>
                    {value.synopsis}&nbsp;
                  </span>
                  )
                } else {
                  return null;
                }
              })}
            </p>
            <p>Like your team, or think you could do better? Click the buttons below to let others know on Twitter just how good of a GM you are or start over completely.</p>
          </div>
          <div id="finished-team" className="player-grid">   
            {selectionArray.map(value => 
              <TeamPlayer
                key={value.name}
                index={value.name}
                details={value}
              />
            )}
          </div>

          <div id="finished-button-group">
            <a className="finish-button" target="_blank" rel="noreferrer" href={this.formatTweet(this.props.selections, this.props.url)}> Tweet team</a>
            <button className="finish-button" onClick={this.props.clearTeam}>Start over</button>
          </div>
        </div>
      </div>
    )
  }
}

export default FinishedTeam;